module.exports = __webpack_public_path__ + "img/use-vpn.f19cdabf.webp";